import React from 'react';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import Courses from 'features/courses';

const Page = () => (
  <UnauthorizedLayout>
    <Courses />
  </UnauthorizedLayout>
);

export default Page;
